// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/img/reisbanner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/img/mission-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/public/img/bulletred.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/public/img/growing.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a {
  text-decoration: none;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.hero-heading {
  font-family: Times New Roman;
  font-weight: 700;
  font-size: 37.14px;
  line-height: 48.12px;
  letter-spacing: 1%;
  text-align: center;
  text-transform: uppercase;
  max-width: 922px;
  margin: 0 auto;
}

.heading-4 {
  font-family: Inter;
  font-weight: 400;
  font-size: 26.5px;
  line-height: 39.46px;
  letter-spacing: -5%;
  text-transform: capitalize;
}

.btn-green {
  height: 46px;
  border-radius: 4.98px;
  background: #0058A0;
  padding: 10px 20px;
  font-family: Inter;
  font-weight: 500;
  font-size: 13.67px;
  line-height: 20.64px;
  letter-spacing: -3%;
  text-transform: capitalize;
  color: #fff !important;
}

.video-btn {
  display: flex;
  width: 110px;
  height: 36px;
  gap: 10px;
  align-items: center;
  font-size: 9.79px;
  padding: 5px;
  justify-content: center;
  font-family: Poppins;
  font-weight: 500;
  font-size: 9.79px;
  line-height: 14.78px;
  letter-spacing: -3%;
  text-transform: capitalize;
  margin-left: 20px;
}

.header-section {
  padding: 120px 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  height: 100vh;
  margin: 0;
}

.head2-39 {
  font-family: Times New Roman;
  font-weight: 700;
  font-size: 39.41px;
  line-height: 55.16px;
  letter-spacing: -3%;
  text-transform: uppercase;
  color: #000000;
}

.head2-46black {
  font-family: Times New Roman;
  font-weight: 700;
  font-size: 46.54px;
  line-height: 75.1px;
  letter-spacing: -3%;
  text-transform: uppercase;
  color: #000000;
}

.smalltext {
  font-family: Inter;
  font-weight: 400;
  font-size: 25.9px;
  line-height: 34.21px;
  letter-spacing: -5%;
  text-transform: capitalize;
  color: #0000008C;

}

.mission {
  padding: 104px 0 0 0;
}

.missionbox {
  padding: 64px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
  background-size: 100% 100%;
  background-position: center;
  min-height: 453px;
  border-radius: 20.61px;
  display: flex;
  flex-flow: column;
  gap: 36px;

}

.missionbox p {
  font-family: Inter;
  font-weight: 400;
  font-size: 25.83px;
  line-height: 42.27px;
  letter-spacing: -5%;
  text-transform: capitalize;
  color: #fff;
}

.boxed-mission {
  display: flex;
  gap: 10px;
  align-items: center;
  font-family: Times New Roman;
  font-weight: 400;
  font-size: 46.21px;
  line-height: 59.88px;
  letter-spacing: -5%;
  text-transform: capitalize;
  color: #fff;
}

.why-reis {
  padding-top: 100px;
}

.whyus {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  align-items: center;
}

.whyus p {
  font-family: Inter;
  font-weight: 400;
  font-size: 23.68px;
  line-height: 38.01px;
  letter-spacing: -5%;
  text-transform: capitalize;
  color: #0000008C;
}

.whyreisimg {
  width: 100%;
  max-width: 784px;
}

.why-content {
  display: flex;
  flex-flow: column;
  gap: 20px;
  align-items: flex-start;
}

.redbullet-list {
  color: #000000;
  font-family: Times New Roman;
  font-weight: 700;
  font-size: 19.08px;
  line-height: 26.7px;
  letter-spacing: -3%;
  text-transform: uppercase;
  list-style: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  display: flex;
  flex-flow: column;
  gap: 17px;
  margin: 0;
  padding-left: 16px;
}

.learn-more {
  font-family: Poppins;
  font-weight: 500;
  font-size: 21.66px;
  line-height: 36.27px;
  letter-spacing: -3%;
  text-transform: capitalize;
  min-width: 300px;
  height: 79px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.reis-team {
  padding-top: 130px;
}

.reisteam-Card {
  display: flex;
  gap: 56px;
  justify-content: center;
  flex-wrap: wrap;
}

.teamcard {
  max-width: 454.1415100097656px;
  min-height: 509.16650390625px;
  border-radius: 20.29px;
  background-color: #F7F7F7;
  padding: 17px;
  text-align: center;
}

.teamcard .social-links {
  display: flex;
  width: auto;
  gap: 20px;
  align-items: center;
  justify-content: center;
}

.teamcard img {
  border-radius: 24.35px;
}

.teamcard .card-title {
  font-family: Poppins;
  font-weight: 600;
  font-size: 25.6px;
  letter-spacing: -7%;
  vertical-align: middle;
  color: #000000;
}

.teamcard .card-text {
  font-family: Poppins;
  font-weight: 400;
  font-size: 21.08px;
  line-height: 36.35px;
  letter-spacing: -5%;
  vertical-align: middle;
  color: #000;
}

.growing-market {
  padding-top: 100px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat;
  background-size: 100% 100%;
  background-position-y: 300px;
  min-height: 1400px;
  padding-bottom: 200px;
}

.growingmarketbox {
  display: flex;
  flex-flow: column;
  gap: 10px;
  padding: 50px 0;
  justify-content: center;
  max-width: 903.9198608398438px;
  margin: 0 auto;
  align-items: center;
}

.growingmarketbox h2 {
  font-family: Times New Roman;
  font-weight: 700;
  font-size: 41.7px;
  line-height: 58.36px;
  letter-spacing: -3%;
  text-transform: uppercase;
  color: #000;
  text-align: center;
}

.growingmarketbox p {
  font-family: Inter;
  font-weight: 400;
  font-size: 25.29px;
  line-height: 40.6px;
  letter-spacing: -5%;
  text-align: center;
  text-transform: capitalize;
  color: #000;
}

.benefits {
  margin-top: 250px;
  margin-bottom: 200px;
  max-width: 741px;
  min-height: 607px;
  border-radius: 26.94px;
  border: 1px solid #0000002B;
  background: #FFFFFF;
  padding: 60px 20px 60px 60px;
  display: flex;
  gap: 25px;
  flex-flow: column;
  justify-content: center;
}

.benefits h2 {
  font-family: Times New Roman;
  font-weight: 700;
  font-size: 33.99px;
  line-height: 47.58px;
  letter-spacing: -3%;
  text-transform: uppercase;
  color: #333333;
}

.benefits p {
  font-family: Inter;
  font-weight: 400;
  font-size: 24px;
  line-height: 41.18px;
  letter-spacing: -5%;
  text-transform: capitalize;
  color: #333333;
}

.benefits .redbullet-list {
  color: #333333 !important;
}

@media (max-width:1199px) {
  .hero-heading {
    font-size: 32px;
  }

  .head2-39 {
    font-size: 36px;
  }

  .head2-46black,
  .boxed-mission {
    font-size: 40px;
  }

  .growingmarketbox h2 {
    font-size: 39px;
  }

  .benefits h2 {
    font-size: 30px;
  }
}

@media (max-width:991px) {
  .hero-heading {
    font-size: 32px;
  }

  .head2-39 {
    font-size: 34px;
  }

  .head2-46black,
  .boxed-mission {
    font-size: 36px;
  }

  .growingmarketbox h2 {
    font-size: 35px;
  }

  .benefits h2 {
    font-size: 28px;
  }

  .benefits p,
  .growingmarketbox p,
  .whyus p,
  .missionbox p,
  .smalltext,
  .heading-4 {
    font-size: 20px;
  }

  .missionbox {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
    background-size: cover;
  }

  .growing-market {
  
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat;
    background-size:cover;
  }
}

@media (max-width:767px) {
  .hero-heading {
    font-size: 30px;
  }

  .head2-39 {
    font-size: 32px;
  }

  .head2-46black,
  .boxed-mission {
    font-size: 34px;
  }

  .growingmarketbox h2 {
    font-size: 32px;
  }

  .benefits h2 {
    font-size: 26px;
  }

  .benefits p,
  .growingmarketbox p,
  .whyus p,
  .missionbox p,
  .smalltext,
  .heading-4 {
    font-size: 18px;
  }

  .whyus {
    grid-template-columns: 1fr;
  }

  .missionbox {
    background-size: cover;   
    padding: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;aACW;AACb;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yDAAmD;EACnD,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;;AAElB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,6DAAuD;EACvD,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,SAAS;;AAEX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mDAA0C;EAC1C,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,6DAAkD;EAClD,0BAA0B;EAC1B,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,SAAS;EACT,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,4BAA4B;EAC5B,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;;;IAME,eAAe;EACjB;;EAEA;IACE,6DAAuD;IACvD,sBAAsB;EACxB;;EAEA;;IAEE,6DAAkD;IAClD,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;;;IAME,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;AACF","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\na {\n  text-decoration: none;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.hero-heading {\n  font-family: Times New Roman;\n  font-weight: 700;\n  font-size: 37.14px;\n  line-height: 48.12px;\n  letter-spacing: 1%;\n  text-align: center;\n  text-transform: uppercase;\n  max-width: 922px;\n  margin: 0 auto;\n}\n\n.heading-4 {\n  font-family: Inter;\n  font-weight: 400;\n  font-size: 26.5px;\n  line-height: 39.46px;\n  letter-spacing: -5%;\n  text-transform: capitalize;\n}\n\n.btn-green {\n  height: 46px;\n  border-radius: 4.98px;\n  background: #0058A0;\n  padding: 10px 20px;\n  font-family: Inter;\n  font-weight: 500;\n  font-size: 13.67px;\n  line-height: 20.64px;\n  letter-spacing: -3%;\n  text-transform: capitalize;\n  color: #fff !important;\n}\n\n.video-btn {\n  display: flex;\n  width: 110px;\n  height: 36px;\n  gap: 10px;\n  align-items: center;\n  font-size: 9.79px;\n  padding: 5px;\n  justify-content: center;\n  font-family: Poppins;\n  font-weight: 500;\n  font-size: 9.79px;\n  line-height: 14.78px;\n  letter-spacing: -3%;\n  text-transform: capitalize;\n  margin-left: 20px;\n}\n\n.header-section {\n  padding: 120px 0;\n  background-image: url('/public/img/reisbanner.png');\n  background-size: cover;\n  background-position: center;\n  height: 100vh;\n  margin: 0;\n}\n\n.head2-39 {\n  font-family: Times New Roman;\n  font-weight: 700;\n  font-size: 39.41px;\n  line-height: 55.16px;\n  letter-spacing: -3%;\n  text-transform: uppercase;\n  color: #000000;\n}\n\n.head2-46black {\n  font-family: Times New Roman;\n  font-weight: 700;\n  font-size: 46.54px;\n  line-height: 75.1px;\n  letter-spacing: -3%;\n  text-transform: uppercase;\n  color: #000000;\n}\n\n.smalltext {\n  font-family: Inter;\n  font-weight: 400;\n  font-size: 25.9px;\n  line-height: 34.21px;\n  letter-spacing: -5%;\n  text-transform: capitalize;\n  color: #0000008C;\n\n}\n\n.mission {\n  padding: 104px 0 0 0;\n}\n\n.missionbox {\n  padding: 64px;\n  background: url('/public/img/mission-bg.png') no-repeat;\n  background-size: 100% 100%;\n  background-position: center;\n  min-height: 453px;\n  border-radius: 20.61px;\n  display: flex;\n  flex-flow: column;\n  gap: 36px;\n\n}\n\n.missionbox p {\n  font-family: Inter;\n  font-weight: 400;\n  font-size: 25.83px;\n  line-height: 42.27px;\n  letter-spacing: -5%;\n  text-transform: capitalize;\n  color: #fff;\n}\n\n.boxed-mission {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  font-family: Times New Roman;\n  font-weight: 400;\n  font-size: 46.21px;\n  line-height: 59.88px;\n  letter-spacing: -5%;\n  text-transform: capitalize;\n  color: #fff;\n}\n\n.why-reis {\n  padding-top: 100px;\n}\n\n.whyus {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  align-items: center;\n}\n\n.whyus p {\n  font-family: Inter;\n  font-weight: 400;\n  font-size: 23.68px;\n  line-height: 38.01px;\n  letter-spacing: -5%;\n  text-transform: capitalize;\n  color: #0000008C;\n}\n\n.whyreisimg {\n  width: 100%;\n  max-width: 784px;\n}\n\n.why-content {\n  display: flex;\n  flex-flow: column;\n  gap: 20px;\n  align-items: flex-start;\n}\n\n.redbullet-list {\n  color: #000000;\n  font-family: Times New Roman;\n  font-weight: 700;\n  font-size: 19.08px;\n  line-height: 26.7px;\n  letter-spacing: -3%;\n  text-transform: uppercase;\n  list-style: url(/public/img/bulletred.png);\n  display: flex;\n  flex-flow: column;\n  gap: 17px;\n  margin: 0;\n  padding-left: 16px;\n}\n\n.learn-more {\n  font-family: Poppins;\n  font-weight: 500;\n  font-size: 21.66px;\n  line-height: 36.27px;\n  letter-spacing: -3%;\n  text-transform: capitalize;\n  min-width: 300px;\n  height: 79px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.reis-team {\n  padding-top: 130px;\n}\n\n.reisteam-Card {\n  display: flex;\n  gap: 56px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.teamcard {\n  max-width: 454.1415100097656px;\n  min-height: 509.16650390625px;\n  border-radius: 20.29px;\n  background-color: #F7F7F7;\n  padding: 17px;\n  text-align: center;\n}\n\n.teamcard .social-links {\n  display: flex;\n  width: auto;\n  gap: 20px;\n  align-items: center;\n  justify-content: center;\n}\n\n.teamcard img {\n  border-radius: 24.35px;\n}\n\n.teamcard .card-title {\n  font-family: Poppins;\n  font-weight: 600;\n  font-size: 25.6px;\n  letter-spacing: -7%;\n  vertical-align: middle;\n  color: #000000;\n}\n\n.teamcard .card-text {\n  font-family: Poppins;\n  font-weight: 400;\n  font-size: 21.08px;\n  line-height: 36.35px;\n  letter-spacing: -5%;\n  vertical-align: middle;\n  color: #000;\n}\n\n.growing-market {\n  padding-top: 100px;\n  background: url(/public/img/growing.png) no-repeat;\n  background-size: 100% 100%;\n  background-position-y: 300px;\n  min-height: 1400px;\n  padding-bottom: 200px;\n}\n\n.growingmarketbox {\n  display: flex;\n  flex-flow: column;\n  gap: 10px;\n  padding: 50px 0;\n  justify-content: center;\n  max-width: 903.9198608398438px;\n  margin: 0 auto;\n  align-items: center;\n}\n\n.growingmarketbox h2 {\n  font-family: Times New Roman;\n  font-weight: 700;\n  font-size: 41.7px;\n  line-height: 58.36px;\n  letter-spacing: -3%;\n  text-transform: uppercase;\n  color: #000;\n  text-align: center;\n}\n\n.growingmarketbox p {\n  font-family: Inter;\n  font-weight: 400;\n  font-size: 25.29px;\n  line-height: 40.6px;\n  letter-spacing: -5%;\n  text-align: center;\n  text-transform: capitalize;\n  color: #000;\n}\n\n.benefits {\n  margin-top: 250px;\n  margin-bottom: 200px;\n  max-width: 741px;\n  min-height: 607px;\n  border-radius: 26.94px;\n  border: 1px solid #0000002B;\n  background: #FFFFFF;\n  padding: 60px 20px 60px 60px;\n  display: flex;\n  gap: 25px;\n  flex-flow: column;\n  justify-content: center;\n}\n\n.benefits h2 {\n  font-family: Times New Roman;\n  font-weight: 700;\n  font-size: 33.99px;\n  line-height: 47.58px;\n  letter-spacing: -3%;\n  text-transform: uppercase;\n  color: #333333;\n}\n\n.benefits p {\n  font-family: Inter;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 41.18px;\n  letter-spacing: -5%;\n  text-transform: capitalize;\n  color: #333333;\n}\n\n.benefits .redbullet-list {\n  color: #333333 !important;\n}\n\n@media (max-width:1199px) {\n  .hero-heading {\n    font-size: 32px;\n  }\n\n  .head2-39 {\n    font-size: 36px;\n  }\n\n  .head2-46black,\n  .boxed-mission {\n    font-size: 40px;\n  }\n\n  .growingmarketbox h2 {\n    font-size: 39px;\n  }\n\n  .benefits h2 {\n    font-size: 30px;\n  }\n}\n\n@media (max-width:991px) {\n  .hero-heading {\n    font-size: 32px;\n  }\n\n  .head2-39 {\n    font-size: 34px;\n  }\n\n  .head2-46black,\n  .boxed-mission {\n    font-size: 36px;\n  }\n\n  .growingmarketbox h2 {\n    font-size: 35px;\n  }\n\n  .benefits h2 {\n    font-size: 28px;\n  }\n\n  .benefits p,\n  .growingmarketbox p,\n  .whyus p,\n  .missionbox p,\n  .smalltext,\n  .heading-4 {\n    font-size: 20px;\n  }\n\n  .missionbox {\n    background: url('/public/img/mission-bg.png') no-repeat;\n    background-size: cover;\n  }\n\n  .growing-market {\n  \n    background: url(/public/img/growing.png) no-repeat;\n    background-size:cover;\n  }\n}\n\n@media (max-width:767px) {\n  .hero-heading {\n    font-size: 30px;\n  }\n\n  .head2-39 {\n    font-size: 32px;\n  }\n\n  .head2-46black,\n  .boxed-mission {\n    font-size: 34px;\n  }\n\n  .growingmarketbox h2 {\n    font-size: 32px;\n  }\n\n  .benefits h2 {\n    font-size: 26px;\n  }\n\n  .benefits p,\n  .growingmarketbox p,\n  .whyus p,\n  .missionbox p,\n  .smalltext,\n  .heading-4 {\n    font-size: 18px;\n  }\n\n  .whyus {\n    grid-template-columns: 1fr;\n  }\n\n  .missionbox {\n    background-size: cover;   \n    padding: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
